var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_vm.visible ? _c('div', {
    staticClass: "chatbot-container"
  }, [_c('div', {
    staticClass: "chatbot-header"
  }, [_c('span', [_vm._v("AI Assistant")]), _c('button', {
    staticClass: "close-btn",
    on: {
      "click": _vm.closeChat
    }
  }, [_vm._v("×")])]), _c('div', {
    ref: "chatBody",
    staticClass: "chatbot-body",
    on: {
      "scroll": _vm.handleScroll
    }
  }, _vm._l(_vm.messages, function (msg) {
    return _c('div', {
      key: msg.id,
      staticClass: "chat-message",
      class: msg.type
    }, [!msg.loading ? _c('p', [_vm._v(_vm._s(msg.text))]) : _c('div', {
      staticClass: "loading-dots"
    }, [_c('span'), _c('span'), _c('span')])]);
  }), 0), _vm.showScrollButton ? _c('button', {
    staticClass: "scroll-bottom-btn",
    on: {
      "click": _vm.scrollToBottom
    }
  }, [_vm._v(" ⬇ ")]) : _vm._e(), _c('div', {
    staticClass: "chatbot-footer"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.userQuestion,
      expression: "userQuestion"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Type your question..."
    },
    domProps: {
      "value": _vm.userQuestion
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.sendMessage($event);
      },
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.userQuestion = $event.target.value;
      }
    }
  }), _c('button', {
    on: {
      "click": _vm.sendMessage
    }
  }, [_vm._v("Send")])])]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }